import React, { useEffect, useRef } from 'react'
import * as G2 from '@antv/g2'
import { getFinanceOverviewTotalIncome, FinanceOverviewIncome } from './finance-overview'

interface DataViewChartRow extends FinanceOverviewIncome {
    date: string
    refund_amount: number | string
}

interface DataViewChartProps {
    dataList: DataViewChartRow[]
    scope: number
}

const formatDate = (value: string, scope: number) => {
    if (!value) return '-'
    if (scope === 2) return value.split('-').slice(0, -1).join('-')
    if (scope === 3) return value.substring(0, 4)

    return value
}

const DataViewChart: React.FC<DataViewChartProps> = props => {
    const chartsRef = useRef<G2.Chart | null>(null)

    useEffect(() => {
        if (chartsRef.current) chartsRef.current.destroy()
        chartsRef.current = new G2.Chart({
            container: 'data-view-chart-container',
            height: 320,
            autoFit: true,
        })

        const chartData = props.dataList
            .slice()
            .sort((a, b) => a.date.localeCompare(b.date))
            .flatMap(row => [
                { date: formatDate(row.date, props.scope), name: '总收款', amount: getFinanceOverviewTotalIncome(row) },
                { date: formatDate(row.date, props.scope), name: '销售额', amount: Number(row.sales_income) || 0 },
                { date: formatDate(row.date, props.scope), name: '充值金额', amount: Number(row.recharge_amount) || 0 },
                { date: formatDate(row.date, props.scope), name: '退款金额', amount: Number(row.refund_amount) || 0 },
            ])

        chartsRef.current.data(chartData)
        chartsRef.current.scale('amount', { tickCount: 5 })
        chartsRef.current.scale('date', { tickCount: 7 })
        chartsRef.current.axis('date', {
            label: {
                style: { fill: '#999' },
            },
        })
        chartsRef.current.axis('amount', {
            label: {
                formatter: (val: string) => `¥${val}`,
                style: { fill: '#999' },
            },
        })
        chartsRef.current.tooltip({ showCrosshairs: true, shared: true })
        chartsRef.current.legend({
            marker: { symbol: 'circle' },
            itemName: {
                style: { fill: '#999', fontSize: 14 },
            },
        })

        const colors = ['#5dc99e', '#5ea1f3', '#e88f5e', '#ed5970']

        chartsRef.current.area().position('date*amount').color('name', colors).style({ fillOpacity: 0.1 })
        chartsRef.current.line().position('date*amount').color('name', colors).style({ lineWidth: 2 })

        chartsRef.current.render()
    }, [props.dataList, props.scope])

    useEffect(() => {
        return () => {
            if (chartsRef.current) chartsRef.current.destroy()
        }
    }, [])

    return <div id="data-view-chart-container" style={{ width: '100%', height: '320px' }} />
}

export default DataViewChart
